import { Registry } from '@react-registry'

export const italicDeserializer = () => {
  return {
    italic: true,
  }
}

Registry.register(italicDeserializer, { id: 'I', registry: 'v2.inline-deserializer' })
Registry.register(italicDeserializer, { id: 'EM', registry: 'v2.inline-deserializer' })
